import { ApiCallsFactory, LocalPersistence } from '../../factories/index'

// validating the required values have been fufilled properly
const validateFormHelper = (
  form: { 
    validateFields: () => { 
      then: (params: () => void) => Promise<void>,
      catch: (error: () => void) => Promise<void>
    } 
  }, 
  setDisableFlag: (a: boolean) => void
) => {
  form.validateFields()
    .then(() => {
      setDisableFlag(false)
    })
    .catch((err: { errorFields: { length: number }}) => {
      err?.errorFields?.length ? setDisableFlag(true) : setDisableFlag(false)
    });
}

// getting the session data
const getSession = async () => {
  const get_session = new LocalPersistence('session')
  const session = await get_session.getSessionPersistence()
  return session
}

// getOtaCode helpe
export const getOTACodes = async (codeType: string, subCat: string) => {
  const getOTA = new ApiCallsFactory(`/searchOTACode?codeType=${codeType}&subCat=${subCat}`)
  const response = await getOTA.getData()
  return response
}
// getCall
const getHelper = async(
  url: string,
) => {
  const currentSession = await getSession()
  const getService = new ApiCallsFactory(`${url}?supplier=${currentSession?.supplier}&propertyid=${currentSession?.propertyId}`,currentSession.token)
  const response = await getService.getData()
  return response
}

const getRolesData = async(
  url: string,
) => {
  const currentSession = await getSession()
  const getService = new ApiCallsFactory(`${url}`,currentSession.token)
  const response = await getService.getData()
  return response
}

// post call
const postHelper = async(
    url: string,
    body: object
  ) => {
  try {
    const currentSession = await getSession()
    const postBody = {
      ...body,
      supplier: currentSession.supplier,
      propertyId: currentSession.propertyId,
    }
    const postService = new ApiCallsFactory(url, currentSession.token, postBody)
    const response = await postService.postData()
    return response
  } catch (error: any) {
    return error
  }
}

// put call
const putHelper = async(
  url: string,
  body: object
) => {
try {
  const currentSession = await getSession()
  const putBody = {
    ...body,
    supplier: currentSession.supplier,
    propertyId: currentSession.propertyId,
  }
  const putService = new ApiCallsFactory(url, currentSession.token, putBody)
  const response = await putService.putData()
  return response
  } catch (error: any) {
    return error
  }
}

// put call
const deleteHelper = async(
  url: string,
  body: object
) => {
try {
  const currentSession = await getSession()
  const deleteBody = {
    ...body,
    supplier: currentSession.supplier,
    propertyId: currentSession.propertyId,
  }
  const putService = new ApiCallsFactory(url, currentSession.token, deleteBody)
  const response = await putService.deleteData()
  return response
  } catch (error: any) {
    return error
  }
}

const onChangeSearch = (
  term: string,
  setSearchTerm: (param: string) => void,
  onDebounce: (param: string) => void
) => {
  setSearchTerm(term)
  onDebounce(term)
}

const recoverSearch = (
  search: string,
  setSearchTerm: (param: string) => void,
  filterData: (param: string) => void,
  onDebounce: (param: string) => void
) => {
  setSearchTerm(search)
  filterData(search)
  onDebounce(search)
}

export {
  validateFormHelper,
  postHelper,
  putHelper,
  deleteHelper,
  getHelper,
  onChangeSearch,
  recoverSearch,
  getRolesData
}
